import {
  type HttpClient,
  type HttpClientRequestOptions,
} from '@service-initiation/shared-clients-http';
import { buildUrl } from '@service-initiation/shared-utils-helpers';

import { type CreateConversionRequest } from './types/CreateConversionRequest';
import { type CreateConversionResponse } from './types/CreateConversionResponse';

export type AppointmentSchedulingServicesClientOptions = {
  baseUrl?: string;
  httpClient: HttpClient;
};

export class ReserveWithGoogleClient {
  private readonly baseUrl: AppointmentSchedulingServicesClientOptions['baseUrl'];

  private readonly httpClient: AppointmentSchedulingServicesClientOptions['httpClient'];

  constructor({
    baseUrl = process.env['RESERVE_WITH_GOOGLE_URL'],
    httpClient,
  }: AppointmentSchedulingServicesClientOptions) {
    this.baseUrl = baseUrl;
    this.httpClient = httpClient;
  }

  public async createConversion(
    request: CreateConversionRequest,
    options?: HttpClientRequestOptions
  ) {
    const url = buildUrl({ baseUrl: this.baseUrl, path: `/collect` });
    const body = JSON.stringify(request);

    return await this.httpClient.post<string, CreateConversionResponse>(
      url,
      body,
      {
        ...options,
        headers: {
          'Content-Type': 'text/plain',
        },
      }
    );
  }
}
